import {useState} from "react";
import GenericDialog from "../../../../../ui/dialogs/generic-dialog/GenericDialog";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Switch from "@material-ui/core/Switch";


const RichiediModificaDeiConsensiPrivacyContent = (props) => {
    const [state, setState] = useState({
        firstPart: false,
        secondPart: false,
        thirdPart: false,
    });
    const agreeButtonState = !(state.firstPart && state.secondPart && state.thirdPart);
    const handleChange = (event) => {
        setState({...state, [event.target.name]: event.target.checked});
    };

    const inputFields = [
        {
            switchState: state.firstPart,
            name: "firstPart",
            label: "Consenso lorem ipsum 1",
            inputLabel: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed et venenatis nisl, ut dictum justo. Maecenas consequat nulla a est suscipit, ac efficitur neque sodales. Nam sit amet ornare neque. Suspendisse consectetur nec est et faucibus. Donec est nibh, volutpat eu ullamcorper in, molestie a diam. Proin viverra efficitur tincidunt. Integer hendrerit quam vel lectus malesuada, in faucibus metus vehicula. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Praesent pulvinar mattis volutpat. Sed vel facilisis quam. Aenean ullamcorper lectus quis nunc volutpat, eget auctor est rhoncus. Donec orci risus, cursus vel velit ac, condimentum molestie felis. Sed condimentum nibh nunc, eu ullamcorper erat feugiat suscipit. Suspendisse cursus ut leo eu rhoncus. Donec et dignissim diam.\n" +
                "\n" +
                "Quisque magna massa, vestibulum sed orci vel, facilisis sollicitudin sem. In bibendum sapien non viverra feugiat. Nunc in aliquam sem. Ut ac pellentesque leo, et interdum ligula. Pellentesque vulputate libero et tortor laoreet, vel sagittis mi luctus. Quisque non porta justo. Phasellus vitae leo sed tellus ultrices rhoncus. Suspendisse semper, lacus sed tempus tincidunt, nisi dolor cursus ex, id bibendum ligula felis ac ex. Donec volutpat efficitur ante, et finibus neque luctus nec. Nunc et leo in erat vestibulum suscipit sed vitae metus. Curabitur placerat sollicitudin tellus, id imperdiet ipsum posuere sed.",
            handleSwitchChange: (event) => {
                handleChange(event)
            },
        },
        {
            switchState: state.secondPart,
            name: "secondPart",
            label: "Consenso lorem ipsum 2",
            inputLabel: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed et venenatis nisl, ut dictum justo. Maecenas consequat nulla a est suscipit, ac efficitur neque sodales. Nam sit amet ornare neque. Suspendisse consectetur nec est et faucibus. Donec est nibh, volutpat eu ullamcorper in, molestie a diam. Proin viverra efficitur tincidunt. Integer hendrerit quam vel lectus malesuada, in faucibus metus vehicula. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Praesent pulvinar mattis volutpat. Sed vel facilisis quam. Aenean ullamcorper lectus quis nunc volutpat, eget auctor est rhoncus. Donec orci risus, cursus vel velit ac, condimentum molestie felis. Sed condimentum nibh nunc, eu ullamcorper erat feugiat suscipit. Suspendisse cursus ut leo eu rhoncus. Donec et dignissim diam.\n" +
                "\n" +
                "Quisque magna massa, vestibulum sed orci vel, facilisis sollicitudin sem. In bibendum sapien non viverra feugiat. Nunc in aliquam sem. Ut ac pellentesque leo, et interdum ligula. Pellentesque vulputate libero et tortor laoreet, vel sagittis mi luctus. Quisque non porta justo. Phasellus vitae leo sed tellus ultrices rhoncus. Suspendisse semper, lacus sed tempus tincidunt, nisi dolor cursus ex, id bibendum ligula felis ac ex. Donec volutpat efficitur ante, et finibus neque luctus nec. Nunc et leo in erat vestibulum suscipit sed vitae metus. Curabitur placerat sollicitudin tellus, id imperdiet ipsum posuere sed.",
            handleSwitchChange: (event) => {
                handleChange(event)
            },
        },
        {
            switchState: state.thirdPart,
            name: "thirdPart",
            label: "Consenso lorem ipsum 3",
            inputLabel: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed et venenatis nisl, ut dictum justo. Maecenas consequat nulla a est suscipit, ac efficitur neque sodales. Nam sit amet ornare neque. Suspendisse consectetur nec est et faucibus. Donec est nibh, volutpat eu ullamcorper in, molestie a diam. Proin viverra efficitur tincidunt. Integer hendrerit quam vel lectus malesuada, in faucibus metus vehicula. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Praesent pulvinar mattis volutpat. Sed vel facilisis quam. Aenean ullamcorper lectus quis nunc volutpat, eget auctor est rhoncus. Donec orci risus, cursus vel velit ac, condimentum molestie felis. Sed condimentum nibh nunc, eu ullamcorper erat feugiat suscipit. Suspendisse cursus ut leo eu rhoncus. Donec et dignissim diam.\n" +
                "\n" +
                "Quisque magna massa, vestibulum sed orci vel, facilisis sollicitudin sem. In bibendum sapien non viverra feugiat. Nunc in aliquam sem. Ut ac pellentesque leo, et interdum ligula. Pellentesque vulputate libero et tortor laoreet, vel sagittis mi luctus. Quisque non porta justo. Phasellus vitae leo sed tellus ultrices rhoncus. Suspendisse semper, lacus sed tempus tincidunt, nisi dolor cursus ex, id bibendum ligula felis ac ex. Donec volutpat efficitur ante, et finibus neque luctus nec. Nunc et leo in erat vestibulum suscipit sed vitae metus. Curabitur placerat sollicitudin tellus, id imperdiet ipsum posuere sed.",

            handleSwitchChange: (event) => {
                handleChange(event)
            },
        },
    ]

    const createRow = (index, switchState, name, label, inputLabel, handleSwitchChange) => {
        return (
            <Grid key={index} item xs={12}>
                <Typography variant="subtitle1"> {label}
                    <Switch checked={switchState} onChange={handleSwitchChange} name={name}/>
                </Typography>
                <Typography variant="body2">
                    {inputLabel}
                </Typography>
            </Grid>
        );
    }

    const dialogContent = (
        <>
            <Grid container spacing={4}>
                <Grid item xs={12} sm={12} md={10}>
                    <Typography component="div" variant="body2">
                        Seleziona i consensi che intendi dare alle diverse opzioni privacy
                    </Typography>
                </Grid>

                {inputFields.map((inputField, index) => (
                    createRow(index, inputField.switchState, inputField.name, inputField.label, inputField.inputLabel, inputField.handleSwitchChange)
                ))}

            </Grid>
        </>
    );

    const dialogActions = (
        <Grid container justifyContent="space-between">
            <Button onClick={props.handleDialogClose} color="primary" variant="outlined">
                <div className="align-center-x px-16">Annulla</div>
            </Button>

            <Button color="primary" variant="contained"
                    disabled={agreeButtonState}
                    onClick={props.handleDialogClose}>
                <div className="align-center-x px-16">Invia</div>
            </Button>
        </Grid>
    );

    return (
        <GenericDialog
            dialogWidth="md"
            open={props.open}
            handleDialogClose={props.handleDialogClose}
            handleDialogCloseButton={props.handleDialogClose}
            dialogActions={dialogActions}
            dialogContent={dialogContent}
        >
            <Typography variant={"h5"}>Richiedi modifica dei consensi privacy</Typography>
        </GenericDialog>
    )
}

export default RichiediModificaDeiConsensiPrivacyContent;
